import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import { ThemeProvider } from "@emotion/react";
import Menu from "@engineering/icons/menu";
import Comment from "@engineering/icons/comment";
import User from "@engineering/icons/user";
import { MembershipPopover, OpeningTimes, useSiteInfo } from "@silvertours/front-entities";
import { PageLegacy, InfoBanner, Header, LoginModal, LoginForm, useLogin } from "@silvertours/front-features";
import { Theme } from "@silvertours/front-shared";
import { useTranslations } from "next-intl";
import { useHeader } from "./useHeader";
import { StyledHeader } from "./Content.style";
var ContactMenu = function() {
    var t = useTranslations("features.supportInfoLegacy");
    return /*#__PURE__*/ _jsx(OpeningTimes, {
        showVoucherInfo: true,
        translations: {
            buttonLabel: t("newDesign.buttonLabel"),
            buttonHref: t("newDesign.buttonHref"),
            title: t("newDesign.title"),
            voucher: {
                buttonLabel: t("newDesign.voucher.buttonLabel"),
                text: t("newDesign.voucher.text")
            }
        }
    });
};
var LoginMobileMenu = function() {
    var ref = useLogin(), isLoggedIn = ref.isLoggedIn, showMobileLogin = ref.showMobileLogin, setShowMobileLogin = ref.setShowMobileLogin;
    var translations = useHeader().translations;
    var handleLoginClick = function(event) {
        event.preventDefault();
        setShowMobileLogin(true);
    };
    var handleSignUpClick = function() {
        window.location.assign(translations.membership.signUpLink);
    };
    if (isLoggedIn) {
        return /*#__PURE__*/ _jsx(Header.LoggedInActions, {
            translations: translations.loginButton
        });
    }
    return showMobileLogin ? /*#__PURE__*/ _jsx(LoginForm, {
        translations: translations.loginModal
    }) : /*#__PURE__*/ _jsx(MembershipPopover, {
        translations: translations.membership,
        handleLoginClick: handleLoginClick,
        handleSignUpClick: handleSignUpClick
    });
};
var makeHamburgerMenu = function(links) {
    return function(handleCloseMenu) {
        return /*#__PURE__*/ _jsx(Header.Navigation, {
            links: links,
            mode: "mobile",
            onAction: handleCloseMenu
        });
    };
};
var ContentDisplay = function(param) {
    var children = param.children, page = param.page;
    var ref;
    var ref1 = useHeader(), getLinks = ref1.getLinks, translations = ref1.translations;
    var headerLinks = getLinks(page.content.navigation.staticLinks);
    var setShowMobileLogin = useLogin().setShowMobileLogin;
    var ref2 = useSiteInfo(), _settings = ref2.settings, hideInfoline = _settings.featureToggles.hideInfoline;
    return /*#__PURE__*/ _jsxs(PageLegacy.PageBase, {
        children: [
            /*#__PURE__*/ _jsxs(ThemeProvider, {
                theme: Theme.defaultTheme,
                children: [
                    /*#__PURE__*/ _jsx(StyledHeader, {
                        desktopActions: [
                            {
                                key: "infoline",
                                component: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Header.Separator, {}),
                                        /*#__PURE__*/ _jsx(Header.InfolinePopoverButton, {
                                            popupContent: /*#__PURE__*/ _jsx(ContactMenu, {})
                                        })
                                    ]
                                }),
                                hide: hideInfoline !== false
                            },
                            {
                                key: "login",
                                component: /*#__PURE__*/ _jsx(Header.LoginButton, {
                                    translations: _object_spread_props(_object_spread({}, translations.loginButton), {
                                        membership: translations.membership
                                    })
                                })
                            }, 
                        ],
                        desktopLinks: headerLinks,
                        mobileMenus: [
                            {
                                id: "mobile-menu-contact",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.openingTimesTooltip,
                                content: ContactMenu,
                                icon: Comment,
                                hide: hideInfoline !== false
                            },
                            {
                                id: "mobile-menu-account",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.loginButton.account,
                                content: LoginMobileMenu,
                                icon: User,
                                onClose: function() {
                                    return setShowMobileLogin(false);
                                }
                            },
                            {
                                id: "mobile-menu-hamburger",
                                closeLabel: translations.closeMenuLabel,
                                iconLabel: translations.menuLabel,
                                content: makeHamburgerMenu(headerLinks),
                                icon: Menu
                            }, 
                        ],
                        children: ((ref = page.content) === null || ref === void 0 ? void 0 : ref.infoBanner) && /*#__PURE__*/ _jsx(InfoBanner, _object_spread({}, page.content.infoBanner))
                    }),
                    /*#__PURE__*/ _jsx(LoginModal, {
                        translations: translations.loginModal
                    })
                ]
            }),
            children,
            /*#__PURE__*/ _jsx(PageLegacy.PageFooter, {})
        ]
    });
};
export { ContentDisplay };
